const STORAGE_KEY = 'ocean_sidebar_collapsed'
const LEGACY_STORAGE_KEY = 'nav-collapsed'
const APP_SIDE_NAV_STORAGE_KEY = 'ocean_app_side_nav_collapsed'

const canUseLocalStorage = (): boolean => {
  try {
    return typeof localStorage !== 'undefined'
  } catch {
    return false
  }
}

export const getSidebarCollapsed = (): boolean => {
  if (!canUseLocalStorage()) return false

  const storedValue = localStorage.getItem(STORAGE_KEY)
  if (storedValue !== null) return storedValue === 'true'

  return localStorage.getItem(LEGACY_STORAGE_KEY) === 'true'
}

export const setSidebarCollapsed = (collapsed: boolean): void => {
  if (!canUseLocalStorage()) return

  const value = collapsed.toString()
  localStorage.setItem(STORAGE_KEY, value)
  localStorage.setItem(LEGACY_STORAGE_KEY, value)
}

export const getAppSideNavCollapsed = (): boolean => {
  if (!canUseLocalStorage()) return false

  return localStorage.getItem(APP_SIDE_NAV_STORAGE_KEY) === 'true'
}

export const setAppSideNavCollapsed = (collapsed: boolean): void => {
  if (!canUseLocalStorage()) return

  localStorage.setItem(APP_SIDE_NAV_STORAGE_KEY, collapsed.toString())
}

export const clearSidebarTracking = (): void => {
  if (!canUseLocalStorage()) return

  localStorage.removeItem(STORAGE_KEY)
  localStorage.removeItem(LEGACY_STORAGE_KEY)
  localStorage.removeItem(APP_SIDE_NAV_STORAGE_KEY)
}

export default {
  getSidebarCollapsed,
  setSidebarCollapsed,
  getAppSideNavCollapsed,
  setAppSideNavCollapsed,
  clearSidebarTracking,
}
